// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_9h-4";
export var collapsed = "_9h-1";
export var headerBar = "_9h-0";
export var leftHeaderContent = "_9h-3";
export var subjectContainer = "_9h-2";